import { Component, ViewEncapsulation } from '@angular/core';
import { MemberDiscountService } from './member-discount.service';
import { UIBlockingService } from '../core/ui-blocking.service';
import { ToastNotificationService } from '../core/toast-notification.service';
import { NgbDropdown, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { merge, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { VerifyRejectRequest } from '../core/verify-reject-request';
import { PendingDiscountDetails } from './DTOs/pending-discount-details';
import { UpdatePendingDiscountRequest } from './DTOs/update-pending-discount-request';
import {CommonLibrary} from "../core/common-library";
import { EditDiscountModalComponent } from './Modals/edit-discount-modal.component';

@Component({
  selector: 'app-pending-discount-review',
  templateUrl: './pending-discount-review.component.html',
    encapsulation: ViewEncapsulation.None,
    providers: [UIBlockingService]

})
export class PendingDiscountReviewComponent {
    constructor(private pendingDiscountService: MemberDiscountService
        , private blockUI: UIBlockingService
        , private notificationService: ToastNotificationService
        , private modalService: NgbModal
        , private route: ActivatedRoute
        , private router: Router) { }

    discount: PendingDiscountDetails;
    dateRangeString: string;

    ngOnInit() {
        this.discount = new PendingDiscountDetails();
        this.getPendingDiscount();
    }

    getPendingDiscount() {
        this.blockUI.start();
        this.pendingDiscountService.getPendingDiscount(parseInt(this.route.snapshot.paramMap.get("id"))).subscribe({
            next: (data) => {
                this.discount = data;
                this.dateRangeString = this.getDateRange();
            },
            error: (err) => {
                this.notificationService.error(err.error.message);
                this.blockUI.stop();
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
            }
        });
    }

    hasStartDatePassed(date: string): boolean {
        const inputDate = new Date(date);
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        return inputDate <= today;
    }

    openEditModal() {
        const modalRef = this.modalService.open(EditDiscountModalComponent, { size: 'lg', backdrop: 'static' });
        modalRef.componentInstance.discount = this.discount;
        modalRef.result.then(response => {
            this.getPendingDiscount();
        })
            .catch(err => {
            });
    }

    getDateRange() {
        var endDateString = CommonLibrary.formatDateIntoString(this.discount.endDate);
        var startDateString = CommonLibrary.formatDateIntoString(this.discount.startDate);
        var hasPassed = this.hasStartDatePassed(startDateString);
        if (!this.discount.startDate && !this.discount.endDate) return "No dates given";
        if (!this.discount.endDate && !hasPassed) return `Starts ${startDateString}`;
        if (!this.discount.endDate && hasPassed) return `Started ${startDateString}`
        if (!this.discount.startDate || hasPassed) return `Ends ${endDateString}`;
        return `${startDateString} until ${endDateString}`;
    }

    PublishArticle(status: number) {
        const req = new VerifyRejectRequest(this.discount.discountId.toString(), this.discount.approverNotes);
        this.pendingDiscountService.changeDiscountStatus(req, status).subscribe({
            next: (data) => {
            },
            error: (err) => {
                this.blockUI.stop();
                this.notificationService.error(err.error.message);
                console.log(err)
            },
            complete: () => {
                this.blockUI.stop();
                this.router.navigate(['admin-portal/chamber/pending-discounts/']);
            }
        });
    }

    protected readonly CommonLibrary = CommonLibrary;

    getDateString(submissionDate: Date) {
        return CommonLibrary.formatDateIntoString(submissionDate);
    }
}
